/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable import/no-extraneous-dependencies */
import _ from 'lodash';
import React, {useState, useRef, useEffect, CSSProperties} from 'react';
import {ViewStyle} from 'react-native';
import {VideoTrackPlayer} from '.';
import {Box} from '../box';
import {AdditionalViewStyle} from '../box/types';

export const VideoNftTrack = ({
  videoSrc,
  artist,
  songTitle,
  isStudioPage,
  additionalStyles,
}: {
  videoSrc: string;
  artist: string;
  songTitle: string;
  isStudioPage?: boolean;
  additionalStyles?: CSSProperties;
}) => {
  // NOTE: This audio logic may not reflect the logic used in the music player context!!

  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [isMute, setIsMute] = useState<boolean>(false);
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [duration, setDuration] = useState<number>(0);
  const [currentTime, setCurrentTime] = useState<number>(0);
  const [isHideControls, setIsHideControls] = useState<boolean>(false);

  const videoPlayer = useRef<HTMLVideoElement | null>(null);

  const togglePlayPause = () => {
    const prevValue = isPlaying;
    if (!duration) {
      setIsLoading(true);
      return;
    }
    if (!prevValue) {
      videoPlayer.current?.play();
      setIsPlaying(!prevValue);
    } else {
      videoPlayer.current?.pause();
      setIsPlaying(!prevValue);
    }
  };

  const toggleSound = () => {
    if (videoPlayer && videoPlayer.current) {
      videoPlayer.current.muted = !videoPlayer.current.muted;
      setIsMute(videoPlayer.current.muted);
    }
  };

  const toggleFullScreen = () => {
    const prevValue = isFullScreen;
    if (!prevValue) {
      setIsFullScreen(!prevValue);
    } else {
      setIsFullScreen(!prevValue);
    }
    if (videoPlayer.current?.requestFullscreen) {
      videoPlayer.current?.requestFullscreen();
    }
  };

  const onHandleHoverInOut = (isHover: boolean) => {
    _.debounce(setIsHideControls, 1000)(!isHover);
  };

  useEffect(() => {
    if (isLoading) {
      togglePlayPause();
    }
  }, [duration]);

  useEffect(() => {
    if (videoPlayer.current) {
      videoPlayer.current.currentTime = 0;
      if (!Number.isNaN(videoPlayer.current?.duration)) {
        setDuration(videoPlayer.current?.duration);
        videoPlayer.current.currentTime = 0;
        setIsLoading(false);
        videoPlayer.current?.play();
        setIsPlaying(true);
      }
      videoPlayer.current?.addEventListener('loadedmetadata', () => {
        const seconds = videoPlayer.current?.duration || 0;
        setDuration(seconds);
        videoPlayer.current?.play();
        setIsPlaying(true);
      });

      videoPlayer.current?.addEventListener('waiting', () => {
        setIsLoading(true);
      });

      videoPlayer.current?.addEventListener('play', () => {
        setIsPlaying(true);
        setIsMute(videoPlayer.current?.muted || false);
      });

      videoPlayer.current?.addEventListener('pause', () => {
        setIsPlaying(false);
        setIsMute(videoPlayer.current?.muted || false);
      });

      videoPlayer.current?.addEventListener('fullscreenchange', () => {
        setIsMute(videoPlayer.current?.muted || false);
      });

      videoPlayer.current?.addEventListener('playing', () => {
        setIsLoading(false);
        setIsMute(videoPlayer.current?.muted || false);
      });

      videoPlayer.current?.addEventListener('ended', () => {
        if (!videoPlayer.current) return;
        videoPlayer?.current.pause();
        setIsPlaying(false);
        videoPlayer.current.currentTime = 0;
        setIsMute(videoPlayer.current?.muted || false);
      });
    }

    return () => {
      if (!videoPlayer.current) return;
      videoPlayer.current.removeEventListener('loadedmetadata', () => {
        const seconds = videoPlayer.current?.duration || 0;
        setDuration(seconds);
        videoPlayer.current?.play();
        setIsPlaying(true);
      });

      videoPlayer.current?.removeEventListener('waiting', () => {
        setIsLoading(true);
      });

      videoPlayer.current?.removeEventListener('play', () => {
        setIsPlaying(true);
        setIsMute(videoPlayer.current?.muted || false);
      });

      videoPlayer.current?.removeEventListener('pause', () => {
        setIsPlaying(false);
        setIsMute(videoPlayer.current?.muted || false);
      });

      videoPlayer.current?.removeEventListener('fullscreenchange', () => {
        setIsMute(videoPlayer.current?.muted || false);
      });

      videoPlayer.current?.removeEventListener('playing', () => {
        setIsLoading(false);
        setIsMute(videoPlayer.current?.muted || false);
      });

      videoPlayer.current?.removeEventListener('ended', () => {
        if (!videoPlayer.current) return;
        videoPlayer?.current.pause();
        setIsPlaying(false);
        videoPlayer.current.currentTime = 0;
        setIsMute(videoPlayer.current?.muted || false);
      });
    };
  }, [videoPlayer.current]);

  return (
    <Box
      onHoverIn={() => !isStudioPage && onHandleHoverInOut(true)}
      onHoverOut={() => !isStudioPage && onHandleHoverInOut(false)}
      zIndex={10}
      bottom={0}
    >
      {isStudioPage ? (
        <Box
          style={{
            minHeight: isStudioPage ? '540px' : '75vh',
            height: isStudioPage ? '540px' : undefined,
            maxHeight: '95vh',
            margin: '12px',
            ...(additionalStyles as ViewStyle & AdditionalViewStyle),
          }}
        >
          <video
            key={videoSrc}
            preload="metadata"
            width="100%"
            height="auto"
            style={{
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)',
              border: '1px solid #53524A',
              borderRadius: '11px',
            }}
            ref={videoPlayer}
            // autoPlay
            muted
            playsInline
          >
            <source src={videoSrc} />
          </video>
        </Box>
      ) : (
        <video
          key={videoSrc}
          preload="metadata"
          width="100%"
          height="auto"
          style={{
            minHeight: isStudioPage ? '540px' : '75vh',
            height: isStudioPage ? '540px' : undefined,
            maxHeight: '95vh',
            ...additionalStyles,
          }}
          // style={{
          //   position: 'absolute',
          //   top: '50%',
          //   transform: 'translateY(-50%)',
          // }}
          ref={videoPlayer}
          // autoPlay
          muted
          playsInline
        >
          <source src={videoSrc} />
        </video>
      )}

      {videoPlayer && videoPlayer.current && (
        <VideoTrackPlayer
          artist={artist}
          songTitle={songTitle}
          isPlaying={isPlaying}
          isLoading={isLoading}
          duration={duration}
          currentTime={currentTime}
          togglePlayPause={togglePlayPause}
          setCurrentTime={setCurrentTime}
          videoPlayer={videoPlayer}
          fullPagePlayer
          toggleSound={toggleSound}
          toggleFullScreen={toggleFullScreen}
          isMute={isMute}
          isHideControls={isHideControls}
          isFullScreen={isFullScreen}
          isStudioPage={isStudioPage}
        />
      )}
    </Box>
  );
};
